import { Injectable } from "@angular/core";

//TODO: why make this injectable, not just a static method that can be imported?
@Injectable()
export class StringFormatterService {
  public formatDate(date: Date) {
    const formattedDate = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date
      .getFullYear()
      .toString()
      .slice(-2)}`;
    return formattedDate;
  }

  public formatDateTime(date: Date) {
    const formattedDateTime = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date
      .getFullYear()
      .toString()
      .slice(-2)} ${date.getHours().toString().padStart(2, "0")}:${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`;
    return formattedDateTime;
  }
}
